import React, { Component } from 'react';
import Isvg from 'react-inlinesvg';
import { Link } from 'react-router-dom';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import logo from '../assets/logo.svg';
import menuIcon from '../assets/hamburger.svg';
import ProfileIcon from '../assets/profile.svg';
import { getSidebarIcon } from '../assets/sidebar';
import { API_ENDPOINT } from '../constants';

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu: null
        }
    }

    renderIcon(item) {
        const localIcon = getSidebarIcon(item.name);
        return (
            <div className={localIcon ? 'icon icon-local' : 'icon'}>
                <Isvg src={localIcon ? localIcon : API_ENDPOINT.replace('testapi', 'api') + item.icon} />
            </div>
        )
    }

    componentDidMount() {
        this.openActiveMenu();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.modulesTree !== this.props.modulesTree || this.getPathname(prevProps) !== this.getPathname(this.props))
            this.openActiveMenu();
    }

    getPathname(props) {
        return props[0] && props[0].location ? props[0].location.pathname : window.location.pathname;
    }

    // keep the dropdown of the current page's parent open
    openActiveMenu() {
        const activeItem = (this.props.modulesTree || []).find((item) => item.modules && item.modules.some((submodule) => this.isActive(submodule.path)));
        if (activeItem && this.state.menu != activeItem._id)
            this.setState({ menu: activeItem._id });
    }

    isActive(path) {
        const pathname = this.getPathname(this.props);
        return !!path && (pathname === path || pathname.indexOf(path + '/') === 0);
    }

    render() {
        return (
            <div className="sidebar">
                <div className="sidebar-header">
                    <Isvg src={logo} className="logo" />
                    <button
                        type="button"
                        className="sidebar-toggle"
                        title={(this.props.sidebarShort ? 'Expand sidebar' : 'Collapse sidebar').translate(this.props.lang)}
                        onClick={this.props.toggleSidebar}
                    >
                        <Isvg src={menuIcon} />
                    </button>
                </div>

                <div className="sidebar-scroll-area">
                    <ul className="main-menu">
                        {
                            this.props.modulesTree.map((item) => {
                                const hasSubmodules = item.modules && item.modules.length > 0;
                                const active = this.isActive(item.path) || (hasSubmodules && item.modules.some((submodule) => this.isActive(submodule.path)));

                                if (!hasSubmodules)
                                    return (
                                        <li key={item._id || item.name}>
                                            <div className={active ? 'main-menu-block active' : 'main-menu-block'}>
                                                <Link to={item.path ? item.path : null}>
                                                    {this.renderIcon(item)}
                                                    <span className="link-text">{item.name}</span>
                                                </Link>
                                            </div>
                                        </li>
                                    )

                                const open = this.state.menu == item._id;
                                return (
                                    <li key={item._id || item.name}>
                                        <div
                                            className={`main-menu-block ${open ? 'dropdown-down' : 'dropdown-up'}${active ? ' active' : ''}`}
                                            onClick={() => this.setState({ menu: open ? null : item._id })}
                                        >
                                            <a>
                                                {this.renderIcon(item)}
                                                <span className="link-text">{item.name}</span>
                                            </a>
                                        </div>
                                        <div className={open ? 'main-menu-dropdown open' : 'main-menu-dropdown'}>
                                            <ul>
                                                {
                                                    item.modules.map((submodule, sidx) => {
                                                        const to = submodule.path ? submodule.path : item.path ? item.path : null;
                                                        return (
                                                            <li key={submodule._id || sidx}>
                                                                <Link to={to} className={this.isActive(submodule.path) ? 'active' : ''}>{submodule.name}</Link>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>

                <div className="sidebar-footer">
                    <UncontrolledDropdown direction="up" className="sidebar-user">
                        <DropdownToggle caret>
                            <div className="profile-icon">
                                <Isvg src={ProfileIcon} />
                            </div>
                            <span className="sidebar-user-name">{this.props.uData && this.props.uData.username}</span>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem className="sidebar-user-logout" onClick={() => this.props.signOut(() => this.props[0].history.push('/login'))}>
                                <Isvg src={getSidebarIcon('Logout')} />
                                <span>{'Logout'.translate(this.props.lang)}</span>
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </div>
            </div>
        )
    }
}

export default Sidebar;
